import { getUser } from "utils";

export const Modules = {
  dashboard: "dashboard",
  client: "client",
  accounts: "accounts",
  analytics: "analytics",
  invoice: "invoice",
  website: "website",
};

export const ALL_ROLES = [
  {
    name: "Admin",
    value: "Admin",
    display: false,
    allow: [
      Modules.dashboard,
      Modules.client,
      Modules.accounts,
      Modules.analytics,
      Modules.invoice,
      Modules.website,
    ],
  },
  {
    name: "Account Manager",
    value: "Account Manager",
    display: true,
    role: ["Admin"],
    allow: [
      Modules.dashboard,
      Modules.client,
      Modules.accounts,
      Modules.analytics,
      Modules.invoice,
      Modules.website,
    ],
  },
  {
    name: "Publisher",
    value: "Publisher",
    display: true,
    role: ["Admin", "Account Manager"],
    allow: [Modules.dashboard, Modules.analytics, Modules.invoice],
  },
  {
    name: "Advertizer",
    value: "Advertizer",
    display: true,
    role: ["Admin", "Account Manager"],
    allow: [
      Modules.dashboard,
      Modules.analytics,
      Modules.invoice,
      Modules.website,
    ],
  },
];

export const ROLES = {
  Admin: "Admin",
  AccountManager: "Account Manager",
  Publisher: "Publisher",
  Advertizer: "Advertizer",
};

export const isModuleAllowed = (name) => {
  const user = getUser();
  return ALL_ROLES.find(e => e.value === user.role).allow.includes(name);
}